export function toOpenAiMinorUnits(value: string | number | null | undefined): number | undefined {
  if (value === null || value === undefined || value === '') return undefined;

  const normalized = typeof value === 'string' ? value.replace(/[^0-9.-]/g, '') : value;
  if (normalized === '') return undefined;

  const amount = Number(normalized);
  if (!Number.isFinite(amount) || amount < 0) return undefined;

  return Math.round(amount * 100);
}
